module.exports = __webpack_public_path__ + "img/sleeve_ruffle_width.35ad0fb9.png";